import React from "react"
import { ChatButtonBody, ChatButtonBodyProps  } from "./ChatButtonBody"
import { ChatButtonMsg, ChatButtonMsgProps } from "./ChatButtonMsg"

interface ChatButtonProps extends ChatButtonBodyProps, ChatButtonMsgProps{
    
}

export const ChatButton:React.FC<ChatButtonProps> = ({errorText, displayEnter, regenerateResponse, btnText}) => {
    return <div className="errorContainer">
        <ChatButtonMsg errorText={errorText} />
        <ChatButtonBody displayEnter={displayEnter} regenerateResponse={regenerateResponse} btnText={btnText}/>
    </div>
} 